/* eslint-disable radix */

import {
  Grid,
  makeStyles,
  IconButton,
  Select,
  MenuItem,
} from '@material-ui/core';
import React from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  setMonth,
  getMonth,
  setYear,
  getYear,
} from 'date-fns';

import { useIntl } from 'react-intl';

const useStyles = makeStyles(() => ({
  iconContainer: {
    padding: 5,
  },
  icon: {
    padding: 10,
    '&:hover': {
      background: 'none',
    },
  },
}));

interface HeaderProps {
  date: Date;
  setDate: (date: Date) => void;
  nextDisabled: boolean;
  prevDisabled: boolean;
  onClickNext: () => void;
  onClickPrevious: () => void;
}

// const MONTHS = [
//   // `${intl.formatMessage( {id: 'datePicker.jan'} )}`,
//   'Feb',
//   'Mar',
//   'Apr',
//   'Máj',
//   'Jún',
//   'Júl',
//   'Aug',
//   'Sept',
//   'Okt',
//   'Nov',
//   'Dec',
// ];

const generateYears = (relativeTo: Date, count: number) => {
  const half = Math.floor(count / 2);
  return Array(count)
    .fill(0)
    .map((_y, i) => relativeTo.getFullYear() - half + i); // TODO: make part of the state
};

const Header: React.FunctionComponent<HeaderProps> = ({
  date,
  setDate,
  nextDisabled,
  prevDisabled,
  onClickNext,
  onClickPrevious,
}: HeaderProps) => {
  const classes = useStyles();

  const intl = useIntl();

  const handleMonthChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setDate(setMonth(date, parseInt(event.target.value as string)));
  };

  const handleYearChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    setDate(setYear(date, parseInt(event.target.value as string)));
  };

  const MONTHS = [
    intl.formatMessage( {id: 'datePicker.jan'} ),
    intl.formatMessage( {id: 'datePicker.feb'} ),
    intl.formatMessage( {id: 'datePicker.mar'} ),
    intl.formatMessage( {id: 'datePicker.apr'} ),
    intl.formatMessage( {id: 'datePicker.may'} ),
    intl.formatMessage( {id: 'datePicker.june'} ),
    intl.formatMessage( {id: 'datePicker.july'} ),
    intl.formatMessage( {id: 'datePicker.aug'} ),
    intl.formatMessage( {id: 'datePicker.sept'} ),
    intl.formatMessage( {id: 'datePicker.okt'} ),
    intl.formatMessage( {id: 'datePicker.nov'} ),
    intl.formatMessage( {id: 'datePicker.dec'} ),    
  ];

  return (
    <Grid container justify="space-between" style={{ alignItems:"center" }} >
      <Grid item className={classes.iconContainer}>
        <IconButton
          className={classes.icon}
          disabled={prevDisabled}
          onClick={onClickPrevious}
        >
          <ChevronLeftIcon color={prevDisabled ? 'disabled' : 'action'} />
        </IconButton>
      </Grid>
      <Grid item >
        <Select
          value={getMonth(date)}
          onChange={handleMonthChange}
          MenuProps={{ disablePortal: true }}
        >
          {MONTHS.map((month, idx) => (
            <MenuItem key={month} value={idx} >
              {month}
            </MenuItem>
          ))}
        </Select>
      </Grid>

      <Grid item>
        <Select
          value={getYear(date)}
          onChange={handleYearChange}
          MenuProps={{ disablePortal: true }}
        >
          {generateYears(date, 30).map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>

        {/* <Typography>{format(date, "MMMM YYYY")}</Typography> */}
      </Grid>
      <Grid item className={classes.iconContainer}>
        <IconButton className={classes.icon} disabled={nextDisabled} onClick={onClickNext}>
          <ChevronRightIcon color={nextDisabled ? 'disabled' : 'action'} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default Header;
